import {SelectItem} from "@/store/types";

export interface TemplatesState {
  templates?: any
  allTemplates: TemplateItem[]
  multichannelTemplates?: any[]
  templateItem?: TemplateItem
  distributions: DistributionItem[]
  templateObject: TemplateItem
}

export interface DistributionItem {
  batchId: string,
  createDatetime: string,
  recipient: number,
  transport: string,
  status: {
    id: number,
    name: string
  },
  comment: string,
  startDatetime: string,
  endDatetime: string
}

export interface DistributionFilter {
  name?: string | null,
  transport?: string | null,
  status?: string | null,
  comment?: string | null,
  page_number?: number,
}

export interface TemplatesFilterParams {
  id?: number,
  is_active?: number | string,
  partner?: string,
  partner_user?: string,
  name?: string,
  status?: string,
  priority?: string,
  message?: string,
  content?: string,
  subject?: string,
}

export interface TemplateItem {
  templateId?: number,
  name: string,
  message?: string,
  lifetime?: number | null,
  startDatetime?: string | null,
  endDatetime?: string | null,
  allowedDays?: string[],
  distribution?: boolean,
  startingDate?: string | null,
  endingDate?: string | null,
  timeBegin?: string | null,
  timeEnd?: string | null,
  senderId?: null | number,
  messageTypeId?: number | null,
  blacklistIds?: number[],
  blacklists?: [],
  multichannelId?: number | null,
  multichannelTemplateId?: number | null,
  timeout?: number|null,
  use_masking?: number | null,
  masked_variables?: string[] | null
  templateParams?: TemplateParamValue[]
}

export interface TemplateMaskedValue {
  message?: string,
  content?: string;
  title?: string;
  vkMessage?: string;
  okMessage?: string;
  subject?: string;
  otp_code_variable?: string | null;
  masked_variables?: string[] | null
}

export interface SmsTemplateItem extends TemplateItem {
  messageLength?: number | null
}

export class TemplateItemImpl implements TemplateItem {
  constructor() {
    this.name = '',
    this.message = '';
    this.lifetime = null,
    this.startDatetime = null,
    this.endDatetime = null,
    this.allowedDays = ['MON','TUE','WED','THU','FRI','SAT','SUN'],
    this.distribution = false,
    this.timeBegin = null,
    this.timeEnd = null,
    this.senderId = null,
    this.messageTypeId = null,
    this.blacklistIds = [],
    this.blacklists = [],
    this.multichannelId = null,
    this.multichannelTemplateId = null,
    this.timeout = null,
    this.use_masking = 0,
    this.masked_variables = []
    this.templateParams = []
  }
  templateId?: number;
  name: string;
  message?: string;
  lifetime?: number | null;
  startDatetime?: string | null;
  endDatetime?: string | null;
  allowedDays?: string[];
  distribution?: boolean;
  timeBegin?: string | null;
  timeEnd?: string | null;
  senderId?: null | number;
  messageTypeId?: number | null;
  blacklistIds?: number[];
  blacklists?: [];
  multichannelId?: number | null;
  multichannelTemplateId?: number | null;
  timeout?: number|null;
  use_masking?: number | null;
  masked_variables?: string[] | null;
  templateParams?: TemplateParamValue[];
}

export class SmsTemplateItemImpl extends TemplateItemImpl {
  messageLength?: number | null

  constructor() {
    super();
    this.messageLength = null;
  }
}

export class CallTemplateItemImpl extends TemplateItemImpl {
  payloadType?: string;
  maxRepeatCount?: number|null
  repeatDtmf?: number|null
  callRedirectDtmf?: number|null
  redirectNumber?: number|null
  sendSmsDtmf?: number|null
  smsTemplateId?: number|null
  dialing?: number|null
  maxRetryCount?: number|null
  retryInterval?: number|null

  constructor() {
    super();
    this.payloadType = '';
    this.maxRepeatCount = null
    this.repeatDtmf = null
    this.callRedirectDtmf = null
    this.redirectNumber = null
    this.sendSmsDtmf = null
    this.smsTemplateId = null
    this.dialing = 30
    this.maxRetryCount = null
    this.retryInterval = null
  }
}

export interface EmailFileItem {
  id?: number,
  name: string,
  fileData: string,
  fileSize?: string
}
export class EmailTemplateItemImpl extends TemplateItemImpl {
  subject?: string;
  from?: string;
  attachedFiles?: EmailFileItem[];
  specialUnsubscribeRule?: string;
  unsubscribeLinksRegex?: string;
  unsubscribeRule?: string;
  subscribeLinksRegex?: string;
  subscribeRule?: string;
  proxyLinksRegex?: string;

  constructor() {
    super();
    this.subject = '';
    this.from = '';
    this.attachedFiles = [];
    this.specialUnsubscribeRule = ''
    this.unsubscribeLinksRegex = ''
    this.subscribeLinksRegex = ''
  }
}

export class PushTemplateItemImpl extends TemplateItemImpl {
  title?: string;
  content?: string;
  applicationId?: number|null;
  multichannelCancelByStatus?: number | null;
  multichannelCancelStatuses?: number[] | null;
  deliveryType?: string;
  customData?: string;
  appGroups?: { id: number; name: string }[];
  appGroupsIds?: number[];
  applications?: { id: number; name: string }[];
  applicationsIds?: number[];
  appByDate?: number | null;
  subByDate: number | null;
  groupSelectionRule?: number | null;
  appSelectionRule?: number | null;

  tapLink?: string = '';
  pushAdditionalParameters?: pushAdditionalParameters[] = [];
  pushButtons?: pushButton[] = [];
  responsibleForView?: string = 'mobile-app';
  groupId?: string = '';
  badgeRule?: string = 'do_not_change';
  androidPushDetails? = {
    groupName: '',
    pushImages: [],
  };
  iosPushDetails? = {
    subtitle: '',
    pushImages: [],
  };
  webPushDetails? = {
    pushImages: [],
  }

  constructor() {
    super();
    this.title = '';
    this.content = '';
    this.applicationId = null;
    this.multichannelCancelByStatus = 0;
    this.subByDate = 1;
    this.applicationsIds = [];
    this.appGroupsIds = [];
  }
}

export type PushImageType = 'banner' | 'logo';

export type pushImages = {
  type?: PushImageType;
  externalUrl?: string;
  internalUrl?: string;
  uploadFilesId?: string | number;
};

export interface PushImagesDetails {
  pushImages?: pushImages[];
}

export interface AcapiUploadedFile {
  id: string | number;
  name?: string;
  internal_url?: string;
  external_url: string;
}

export type PushPlatformKey = 'android' | 'ios' | 'web';

export type pushAdditionalParameters = {
  name: string;
  value: string;
}

export type pushButton = {
  id: string;
  text?: string;
  appointment: string;
  appointmentValue?: string;
}

export class ViberTemplateItemImpl extends TemplateItemImpl {
  image?: string;
  buttonName?: string;
  buttonLink?: string;
  attachmentFileId?: string = undefined;

  constructor() {
    super();
    this.image = '';
    this.buttonName = '';
    this.buttonLink = '';
  }
}

export class WhatsAppTemplateItemImpl extends TemplateItemImpl {
  image?: string = '';
  buttonName?: string = '';
  buttonLink?: string = '';
}

export class TelegramOtpTemplateItemImpl extends TemplateItemImpl {
  otp_code_variable?: string | null = 'OTP';
}

export class CustomTemplateItemImpl extends TemplateItemImpl {
  image?: string;
  buttonName?: string;
  buttonLink?: string;
  custom_parameters?: any;

  constructor() {
    super();
    this.image = '';
    this.buttonName = '';
    this.buttonLink = '';
    this.custom_parameters = []
  }
}

export class MailNotifyTemplateItemImpl extends TemplateItemImpl {
  mnServiceId: number|null;
  mnTemplateId: number|null;
  routes: string;
  vkMessage: string;
  okMessage: string;
  multichannelCancelByStatus?: number | null;
  multichannelCancelStatuses?: number[] | null;

  constructor() {
    super();
    this.mnServiceId = null;
    this.mnTemplateId = null;
    this.routes = 'vk';
    this.vkMessage = '';
    this.okMessage = '';
    this.multichannelCancelByStatus = 0;
  }
}

export interface TemplateParamValue {
  template_params_list_id: number | null;
  value: string;
}

export type uploadedFile = {
  id: string,
  name?: string,
  internal_url?: string,
  external_url: string,
  size?: number,
  upload_date?: string,
  path?: string,
  server?: string,
}